import { useTranslation } from "react-i18next";
import Collapse from "../../common/Collapse";
import { formatDate } from "../../../utils/manipulateText";
import CircularProgress from "../../common/CircularProgress";

export default function VideoInfoSection({ videoData }) {
  const { t } = useTranslation();

  if (!videoData) {
    return null;
  }

  return (
    <Collapse
      title={
        <div className="font-semibold text-gray-800 text-2xl">
          {t("video information")}
        </div>
      }
      defaultOpen
      className="mb-6"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 divide-x">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("creation date")}
            </label>
            <p className="text-gray-900 font-semibold">
              {formatDate(videoData.createdAt)}
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("progress")}
            </label>
            <div className="flex items-center gap-4">
              <CircularProgress
                percentage={Number(videoData.progress) * 100}
                size={40}
                strokeWidth={4}
                color="text-empower-500"
                backgroundColor="text-gray-200"
                className="w-10 h-10"
                fontSize={10}
              />
              {Number(videoData.progress) === 0.95 && (
                <p className="text-xs text-gray-700 mt-2">
                  {t("video is being processed")}
                </p>
              )}</div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("video creation type")}
            </label>
            <p className="text-gray-700">
              {t(videoData.creationType) || t("unknown")}
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("template")}
            </label>
            <p className="text-gray-700">
              {videoData.template || t("unknown")}
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("is published")}
            </label>
            <p className="text-gray-700">
              {videoData.isPublished ? t("yes") : t("no")}
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("creation id")}
            </label>
            <p className="text-gray-600 text-sm font-mono">
              {videoData.creationId}
            </p>
          </div>
        </div>

        {videoData.videoUrl && (
          <div className="pl-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t("video preview")}
            </label>
            <div className="relative w-full" style={{ aspectRatio: "16 / 9" }}>
              <video
                src={videoData.videoUrl}
                controls
                className="w-full h-full rounded-lg border border-gray-300"
              >
                {t("your browser does not support the video tag")}
              </video>
            </div>
          </div>
        )}
      </div>
    </Collapse>
  );
}
